export default __webpack_public_path__ + "static/B0054-d93a5da95914b45d2a7c15f1c0bf4f58.png";